module.exports = __webpack_public_path__ + "img/img-a13d57.png";